export enum IssuanceMonitorTab {
    Deals = 'deals',
    Dashboard = 'dashboard',
    IOIs = 'iois',
    ArrangerPipeline = 'arranger-pipeline',
    ArrangerPipelineEdit = 'arranger-pipeline-edit',
}

// Backward compatibility for old IM links
export type ImTabQueryStringParam = 'deals' | 'dashboard' | 'iois' | 'arrangerPipeline' | 'arrangerPipelineEdit'

export function convertImTabQueryStringParamToEnum(param: ImTabQueryStringParam | IssuanceMonitorTab) {
    switch (param.toLowerCase()) {
        case 'dashboard':
            return IssuanceMonitorTab.Dashboard;
        case 'iois':
            return IssuanceMonitorTab.IOIs;
        case IssuanceMonitorTab.ArrangerPipeline:
        case 'arrangerPipeline'.toLowerCase():
            return IssuanceMonitorTab.ArrangerPipeline;
        case IssuanceMonitorTab.ArrangerPipelineEdit:
        case 'arrangerPipelineEdit'.toLowerCase():
            return IssuanceMonitorTab.ArrangerPipelineEdit;
        default:
            return IssuanceMonitorTab.Deals;
    }
}